export default {
  de: {
    title: 'Dokument Kategorien',
    create: 'Kategorie hinzufügen',
    active: 'aktiv',
    inactive: 'inaktiv',
    newName: 'Neue Dokument Kategorie',
  },
};
